export const SEGMENTS = [
  { id: '1', name: 'Estado', key: 'estado' },
  { id: '2', name: 'Canais de mídia', key: 'canaisMidia' },
  { id: '3', name: 'Categorias', key: 'categorias' },
  { id: '4', name: 'CNPJ e CPF', key: 'cnpj' },
];
